import { fromEvent } from 'rxjs';

export const onWindowBeforeUnload = fromEvent(window, 'beforeunload');
